module.exports = __webpack_public_path__ + "static/media/GCP_contentsPage_ko.e0bc1ba3.png";